
import "./Attention.less";
import {getLocalData, pageShareConfig, setDocTitle} from 'utils/util';
import test_qr_code from '../../static/img1/test_attention.png'
import online_qr_code from '../../static/img1/online_attention.png'

const React = require('react');
class UnAttention extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    componentWillMount(){
        setDocTitle('查询工具送给你');
    }
    componentDidMount() {
        // pageShareConfig(this.user_detail.id);
        console.log(document.referrer);
        // {window.location.href.indexOf('.t.') == -1 && _hmt.push(['_trackEvent', '网站推广来源', `${document.referrer}`, '', ''])}
    }
    render() {
        return (
            <div
                className="attention-page"
                style={{background:window.location.hostname=='xk.shijieu.cn'?'#334cd5':'#0E1B63'}}>
                <div className='img'>
                    {window.location.hostname=='xk.shijieu.cn'?<img src={online_qr_code} alt=""/>:<img src={test_qr_code} alt=""/>}
                </div>
            </div>
        )
    }
}
export default UnAttention




// WEBPACK FOOTER //
// ./src/pages/SelectSubject/Attention.js